import { createSvgComponent } from "../../icon/createSvgComponent";
import Hamburger from "@core/__generated__/icon/figma/hamburger.svg";
export default createSvgComponent(Hamburger);